// extracted by mini-css-extract-plugin
export default {"footer":"Index_footer__UzlwC","footer_item":"Index_footer_item__3YKmX","footer_item_image":"Index_footer_item_image__DBDlV","footer_item_text":"Index_footer_item_text__A2sYg"};